module.exports = __webpack_public_path__ + "img/dialog_train.d8c2e05f.svg";